import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-6 bg-white/50" data-id="element-204">
      <div className="max-w-3xl mx-auto space-y-16" data-id="element-205">
        {/* Part 1 - Opening Hook */}
        <FadeIn data-id="element-206">
          <div className="prose prose-lg md:prose-xl text-warmgray" data-id="element-207">
            <p className="first-letter:text-5xl first-letter:font-playfair first-letter:text-terracotta first-letter:mr-1 first-letter:float-left" data-id="element-208">
              Es domingo por la noche. Estás frente al espejo probándote la ropa
              para mañana y ocurre lo de siempre: el botón no cierra, la
              cremallera aprieta y tu abdomen se ve hinchado, como si hubieras
              ganado dos kilos en un solo fin de semana.
            </p>
            <p className="mt-6" data-id="element-209">
              No es falta de disciplina y no es que hayas "engordado" de la
              noche a la mañana. Es inflamación celular y retención de líquidos
              provocada por un metabolismo que, después de los 35 años, ya no
              perdona ni el estrés ni los excesos del fin de semana.
            </p>
          </div>
        </FadeIn>

        {/* Divider */}
        <FadeIn delay={0.1} data-id="element-210">
          <div className="flex justify-center items-center gap-4 py-4" data-id="element-211">
            <div className="h-px w-16 bg-sage/30" data-id="element-212"></div>
            <div className="w-2 h-2 rounded-full bg-sage/50" data-id="element-213"></div>
            <div className="h-px w-16 bg-sage/30" data-id="element-214"></div>
          </div>
        </FadeIn>

        {/* Part 2 - The Problem */}
        <FadeIn delay={0.2} data-id="element-215">
          <div className="bg-cream p-8 md:p-10 rounded-2xl border border-terracotta/10 shadow-sm" data-id="element-216">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-charcoal" data-id="element-217">
              La trampa metabólica de los 35
            </h3>
            <div className="space-y-6 text-lg text-warmgray" data-id="element-218">
              <p data-id="element-219">
                Después de los 35, tu cuerpo se vuelve más sensible a los picos
                de insulina y al cortisol. Una cena con sodio, una copa de vino
                o simplemente el estrés de la semana activan una señal de
                emergencia que ordena a tus células "secuestrar" agua.
              </p>
              <p data-id="element-220">
                Te levantas sintiéndote bien, pero a medida que pasan las horas,
                tu vientre se expande. Sientes pesadez, cansancio mental y esa
                frustrante sensación de que tu cuerpo ya no responde a las
                dietas que antes te funcionaban.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}